import { bootstrap } from '@angular/platform-browser-dynamic';
import { HTTP_PROVIDERS } from '@angular/http';
import { provide } from '@angular/core';
import { ROUTER_PROVIDERS } from '@angular/router-deprecated';
import { HashLocationStrategy, LocationStrategy, Location } from '@angular/common';

import '!style!css!postcss!sass!./scss/main.scss';

import { MainComponent } from './main/MainComponent';
import { HeaderFactory } from './common/HeaderFactory';
import { LoadingService } from './services';
import { LoadIndicator } from './common/LoadIndicator';

declare const OidcTokenManager;
declare const FEDERATION_ISSUER: string;
declare const SILENT_RENEWAL_PAGE: string;

function bootstrapApp() {
    if (location.hash.match(/id_token/)) {
        window.location.href = location.href.replace(location.hash, localStorage.getItem('deeplink') || '');
        localStorage.removeItem('deeplink');
    }

    bootstrap(MainComponent, [
        ROUTER_PROVIDERS,
        HTTP_PROVIDERS,
        provide(LocationStrategy, { useClass: HashLocationStrategy }),
        HeaderFactory,
        LoadingService
    ]);
}

const mgr = window['mgr'] = new OidcTokenManager({
    authority: FEDERATION_ISSUER,
    client_id: 'campusLabsWeb',
    redirect_uri: location.href.replace(location.hash, ''),
    prompt: 'login',
    post_logout_redirect_uri: location.href.replace(location.hash, ''),
    response_type: 'id_token token',
    scope: 'openid institution',
    silent_redirect_uri: window.location.origin + window.location.pathname + 'silent.html',
    silent_renew: true,
    store: window.sessionStorage || null
});

if (!location.hash.match(/id_token/)) {
    localStorage.setItem('deeplink', location.hash);
}

if (mgr.expired) {
    if (location.hash.match(/id_token/)) {
        mgr.processTokenCallbackAsync().then(bootstrapApp);
    } else {
        mgr.redirectForToken();
    }
} else {
    bootstrapApp();
}


/** WEBPACK FOOTER **
 ** ./app/bootstrap.ts
 **/